import request from "@/utils/request";
import { praseStrEmpty } from "@/utils/common";

export function userSign(date) {
    return request({
        headers: {
            isToken: false,
        },
        url: `/login`,
        method: "post",
        data: date
    })
}

export function anonymousLogin(date) {
    return request({
        headers: {
            isToken: false,
        },
        url: `/anonymousLogin`,
        method: "post",
        data: date
    })
}

export function handleSample(date) {
    return request({
        url: `/handleSample`,
        method: "post",
        data: date
    })
}

// 获取验证码
export function getCodeImg() {
    return request({
        url: '/captchaImage',
        method: 'get'
    })
}
// 新增用户
export function addUser(data) {
    return request({
        url: '/system/user',
        method: 'post',
        data: data
    })
}

// 修改用户
export function updateUser(data) {
    return request({
      url: '/system/user',
      method: 'put',
      data: data
    })
}
// 删除用户
export function delUser(userId) {
    return request({
      url: '/system/user/' + userId,
      method: 'delete'
    })
}

// 获取用户详细信息
export function getInfo() {
    return request({
        url: '/getInfo',
        method: 'get'
    })
}


// 项目新增
export function newProject(data) {
    return request({
        url: `/mdapPrivate/api/v1/project/save`,
        method: "post",
        data: data,
    });
}

// 项目列表
export function projectList(data) {
    return request({
        url: `/mdapPrivate/api/v1/project/list`,
        method: "post",
        data: data,
    });
}

// 项目修改
export function projectUpdate(data) {
    return request({
        url: `/mdapPrivate/api/v1/project/update`,
        method: "post",
        data: data,
    });
}

// 单条项目查询
export function queryproject() {
    return request({
        url: `/mdapPrivate/api/v1/project/selectInfoById/904fce20b7444471b93937e56603a66b`,
        method: "get",
    });
}

// 项目删除
export function detailproject(dataId) {
    return request({
        url: `/mdapPrivate/api/v1/project/delete/${dataId}`,
        method: "get",
    });
}

// 文具工具
export function toolList(data) {
    return request({
        url: `/mdap-private/api/v1/tool/list`,
        method: "post",
        data: data,
    });
}


// 项目管理--根据id查询详情
export function newprojectDetail(dataId) {
    return request({
        url: `/mdap/api/v1/project/selectInfoById/${dataId}`,
        method: "get",
    });
}

// 项目管理--新增文件夹
export function newFolder(data){
    return request({
        url: `/mdap/api/v1/folder/save`,
        method: "post",
        data: data,
    });
}

// 项目管理--根据id查询文件夹名称
export function folderList(projectId) {
    return request({
        url: `/mdap/api/v1/folder/selectListByProjectId/${projectId}`,
        method: "get",
    });
}

// 项目管理--文件上传
export function uploadfile(data) {
    return request({
        headers: {
            'Content-Type': 'multipart/form-data' //改这里就好了
        },
        url: `/mdap/api/v1/dataRecord/dataRecordUpload`,
        method: "post",
        data: data,
    })
}

// 资料记录新增
export function dataRecordSave(data) {
    return request({
        url: `/mdap/api/v1/dataRecord/save`,
        method: "post",
        data: data,
    });
}

// 项目管理--根据id下载文件
export function downloadlist(fileId) {
    return request({
        url: `/mdap/api/v1/file/download/${fileId}`,
        method: "get",
    });
}

// 项目管理--根据id查询列表
export function queryfolderList(id) {
    return request({
        url: `/mdap/api/v1/folder/selectDataRecordList/${id}`,
        method: "get",
    });
}

// 项目管理--根据id删除文件
export function feleteFail(id) {
    return request({
        url: `/mdap/api/v1/folder/delete/${id}`,
        method: "get",
    });
}

// 资料记录新增
export function projectUpdateContent(data) {
    return request({
        url: `/mdap/api/v1/project/update`,
        method: "put",
        data: data,
    });
}

// 文件夹---根据文件名称查询文件夹列表
export function folderqueryName(name, projectId) {
    return request({
        url: `/mdap/api/v1/folder/selectInfoByName/${name}/${projectId}`,
        method: "get",
    });
}

// 企业新增
export function enterpriseSave(data) {
    return request({
        url: `/mdap/api/v1/enterprise/save`,
        method: "post",
        data: data,
    });
}


// 查询企业列表
export function enterpriseList(data) {
    return request({
        url: `/mdap/api/v1/enterprise/list`,
        method: "post",
        data: data,
    });
}


// 根据id删除企业
export function deleteEnter(dataId) {
    return request({
        url: `/mdap/api/v1/enterprise/delete/${dataId}`,
        method: "get",
    });
}

/**
 * 根据字典类型查询数据字典
 * @param {字典类型} type
 */
export function queryDictionary(type) {
    return new Promise((go) => {
        request({
            url: `/system/dict/data/type/${type}`,
            method: "get",
        }).then((res) => {
            go(res);
        });
    });
}

// 查询受邀通知列表
export function invitedList(data) {
    return request({
        url: `/mdap/api/v1/invited/list`,
        method: "post",
        data: data,
    });
}


// 获取分组项目列表
export function groupList(data) {
    return request({
        url: `/mdap/api/v1/tool/groupList`,
        method: "post",
        data: data,
    });
}

// 根据名称查询工具
export function queryToolList(toolName) {
    return request({
        url: `/mdap/api/v1/tool/selectInfoByToolName/${toolName}`,
        method: "get",
    });
}

// 根据用户id查询企业列表
export function selectBusInfoList(date){
    return request({
        url:'/mdap/api/v1/enterprise/list',
        method:'post',
        data:date
    })
}

//批量删除员工

export function deleteByIds(data) {
    return request({
        url: `/mdap/api/v1/enterpriseStaff/deleteByIds`,
        method: "post",
        data: data,
    });
}
// 加入受邀通知列表
export function invitedJoin(data) {
    return request({
        url: `/mdap/api/v1/invited/join`,
        method: "post",
        data: data,
    });
}

// 根据id查询详情
export function selectBusInfoById(dataId){
    return request({
        url:`/mdap/api/v1/enterprise/selectInfoById/${dataId}`,
        method:'get'
    })
}

// 企业部门列表查询
export function enterpriseDept(date){
    return request({
        url:'/mdap/api/v1/enterpriseDept/list',
        method:'post',
        data:date
    })
}
// 删除部门
export function enterpriseDeptdDlete(dataId){
    return request({
        url:`/mdap/api/v1/enterpriseDept/delete/${dataId}`,
        method:'get'
    })
}

// 新增部门
export function addEnterpriseDept(date){
    return request({
        url:'/mdap/api/v1/enterpriseDept/save',
        method:'post',
        data:date
    })
}
// 团队管理--邀请成员
export function teamManageInvitation(data) {
    return request({
        url: `/mdap/api/v1/teamManage/invitation`,
        method: "post",
        data: data,
    });
}

// 查询用户角色
export function userProjectRole(data) {
    return request({
        url: `/mdap/api/v1/userProjectRole/list`,
        method: "post",
        data: data,
    });
}
``
// 查询部门人员
export function selectEnterpriseStaff(id) {
    return request({
        url: `/mdap/api/v1/enterpriseDept/selectEnterpriseStaff/${id}`,
        method: "get",
    });
}

// 部门添加成员
export function invitationDete(date){
    return request({
        url:'/mdap/api/v1/enterpriseStaff/invitation',
        method:"post",
        data:date
    })
}

// 查询不再当前项目下的企业员工
export function selectEnterpriseStaffAgin(date) {
    return request({
        url: `/mdap/api/v1/enterpriseStaff/selectNonProjectInfo`,
        method: "post",
        data:date
    });
}


// 获取团队管理下成员列表
export function teamManageList(date) {
    return request({
        url: `/mdap/api/v1/teamManage/list`,
        method: "post",
        data:date
    });
}

// 删除团队管理
export function deleteTeam(dataId) {
    return request({
        url: `/mdap/api/v1/teamManage/delete/${dataId}`,
        method: "get",
    });
}


// 团队成员修改角色
export function teamManageUpdate(data) {
    return request({
        url: `/mdap/api/v1/teamManage/update`,
        method: "put",
        data: data,
    });
}

// 保存流程图
export function workflowSave(date) {
    return request({
        url: `/mdap-private/api/v1/workflow/saveOrUpdate`,
        method: "post",
        data: date
    });
}

// 获取所有流程图
export function workflowList(date) {
    return request({
        url: `/mdap/api/v1/workflow/list`,
        method: "post",
        data: date
    });
}

// 根据id获取流程
export function workflowID(id) {
    return request({
        url: `/mdap/api/v1/workflow/${id}`,
        method: "get",
    });
}



// 运行工作流
export function workflowRun(date) {
    return request({
        url: `/mdap-private/api/v1/workflow/run`,
        method: "post",
        data: date
    });
}


// 校验DAG是否规范
export function workflowValidDag(date) {
    return request({
        url: `/mdap-private/api/v1/workflow/validDag`,
        method: "post",
        data: date
    });
}

// 根据企业id查询员工信息
export function selectInfoByEnterpriseId(enterpriseId){
    return request({
        url:`mdap/api/v1/enterpriseStaff/selectInfoByEnterpriseId/${enterpriseId}`,
        method:'get'
    })
}

export function enterpriseStaffList(date) {
    return request({
        url: `/mdap/api/v1/enterpriseStaff/list`,
        method: "post",
        data: date
    })
}



// 根据工具id新增工作流节点
export function workflowNodeAdd(toolId) {
    return request({
        url: `/mdap-private/api/v1/workflow/${toolId}/node/add`,
        method: "post",
        data: toolId
    });
}



// 保存流程图将G6json数据保存在服务器接口
export function storeg6Json(toolId) {
    return request({
        url: `/mdap-private/api/v1/wfGraph`,
        method: "post",
        data: toolId
    });
}


// 根据流程id获取g6json数据
export function queryG6json(workflowId) {
    return request({
        url: `/mdap-private/api/v1/wfGraph/${workflowId}/workflow`,
        method: "get",
    });
}

// 根据id查询
export function workflowProjectId(projectId) {
    return request({
        url: `/mdap-private/api/v1/workflow/${projectId}/project`,
        method: "get",
    });
}

// 单点调试接口
export function jobsRun(data) {
    return request({
        url: `/mdap-private/api/v1/jobs/run`,
        method: "post",
        data: data,
    });
}

// 更新企业员工
export function updata(date){
    return request({
        url:'/mdap/api/v1/enterpriseStaff/update',
        method:'put',
        data:date
    })
}

// 根据id删除企业员工
export function deleteUser(dataId){
    return request({
        url:`/mdap/api/v1/enterpriseStaff/delete/${dataId}`,
        method:'get',
    })
}

// 新建文件夹
export function newFolders(data) {
    return request({
        url: `/mdap/api/v1/folder/save`,
        method: "post",
        data: data
    });
}


// 样本数据批量上传接口
export function sampleUploads(data) {
    return request({
        url: `/mdap/api/v1/sample/sampleUpload`,
        method: "post",
        data: data
    });
}


// 样本数据新增接口
export function sampleSave(data) {
    return request({
        url: `/mdap-private/api/v1/sample/save`,
        method: "post",
        data: data
    });
}

// 根据项目id查询详情
export function selectInfoById(projectId) {
    return request({
        url: `/mdap-private/api/v1/sample/selectInfoByProjectId/${projectId}`,
        method: 'get',
    })
}


// 样本数据新增接口
export function sampleUpdate(data) {
    return request({
        url: `/mdap/api/v1/sample/update`,
        method: "put",
        data: data
    });
}





//根据项目id获取任务实例列表
export function instanceList(date) {
    return request({
        url: '/mdap-private/api/v1/jobs/instance/list',
        method: 'post',
        data: date
    })
}


//获取工作流实例列表
export function workflowInstanceList(date) {
    return request({
        url: '/mdap-private/api/v1/workflow/instance/list',
        method: 'post',
        data: date
    })
}



//获取任务实例日志
export function instanceLogList(instanceId) {
    return request({
        url: `/mdap-private/api/v1/jobs/instance/${instanceId}/log`,
        method: 'post',
        data: instanceId
    })
}
//获取脚本
export function instanceSystemLogList(instanceId) {
    return request({
        url: `/mdap-private/api/v1/jobs/instance/${instanceId}/script/log`,
        method: 'get'
    })
}

//重试任务
export function instanceretry(instanceId) {
    return request({
        url: `/mdap-private/api/v1/jobs/instance/${instanceId}/retry`,
        method: 'post',
        data: instanceId
    })
}

//停止任务
export function instancestop(instanceId) {
    return request({
        url: `/mdap-private/api/v1/jobs/instance/${instanceId}/stop`,
        method: 'post',
        data: instanceId
    })
}


//根据任务实例id获取执行结果
export function executeResultList(jobInstanceId) {
    return request({
        url: `/mdap-private/api/v1/executeResult/job/${jobInstanceId}/instance/list`,
        method: 'post',
        data: jobInstanceId
    })
}

// 根据id删除文件
export function deleteFile(dataId) {
    return request({
        url: `/mdap-private/api/v1/sample/deleteFile/${dataId}`,
        method: 'get',
    })
}


//重试工作流
export function workflowRetry(instanceId) {
    return request({
        url: `/mdap-private/api/v1/workflow/instance/${instanceId}/retry`,
        method: 'post',
        data: instanceId
    })
}

//停止工作流
export function workflowStop(instanceId) {
    return request({
        url: `/mdap-private/api/v1/workflow/instance/${instanceId}/stop`,
        method: 'post',
        data: instanceId
    })
}

//文件匹配
export function sampleFileMatch(projectId,data) {
    return request({
        url: `/mdap-private/api/v1/sample/fileMatchForRule/${projectId}`,
        method: 'post',
        data: data
    })
}

//生成样本文件集查询
export function selectSampleFileSetList(data) {
    return request({

        url: `/mdap-private/api/v1/sample/selectSampleFileSetList`,
        method: 'post',
        data: data
    })
}

//文件匹配 匹配所有文件
export function fileMatchForAll(projectId, name) {
    return request({
        url: `/mdap-private/api/v1/sample/fileMatchForAll/${projectId}/${name}`,
        method: 'get',
    })
}

//删除文件夹
export function deletefolderFolderName(projectId, name) {
    return request({
        url: `/mdap/api/v1/sample/deleteByProjectIdAndName/${projectId}/${name}`,
        method: 'get',
    })
}


//校验上游节点是否可以运行
export function jobsCheckUpstream(nodeId, projectId) {
    return request({
        url: `/mdap-private/api/v1/jobs/${nodeId}/${projectId}/check/upstream`,
        method: 'post',
        data: nodeId
    })
}

//根据项目id查询
export function queryFileStandard(projectId) {
    return request({
        url: `/mdap-private/api/v1/fileStandard/selectInfoByProjectId/${projectId}`,
        method: 'get',
    })
}

//生成样本文件集查询
export function fileSetList(data) {
    return request({
        url: `/mdap-private/api/v1/sample/selectSampleFileSetList`,
        method: 'post',
        data: data
    })
}


//批量删除文件集
export function deleteSampleFile(ids) {
    return request({
        url: `/mdap-private/api/v1/sample/deleteSampleFileSet`,
        method: 'post',
        data: ids
    })
}


//根据工具id查询
export function querySelectInfo(data) {
    return request({
        url: `/mdap/api/v1/toolTemplate/selectList`,
        method: 'post',
        data:data
    })
}



// 工具模板项的修改
export function toolTeamManage(data) {
    return request({
        url: `/mdap/api/v1/toolTemplate/update`,
        method: "put",
        data: data,
    });
}


// 工具参数模板项查询
export function toolTeamManageTerm(data) {
    return request({
        url: `/mdap-private/api/v1/toolTemplate/selectToolTemplateTerm`,
        method: "post",
        data: data,
    });
}


// 工具参数模板项查询
export function selectToolTeamManage(toolId) {
    return request({
        url: `/mdap-private/api/v1/toolTemplate/selectListByToolId/${toolId}`,
        method: "get",
    });
}


// 工具模板项批量新增
export function newToolTemplate(data) {
    return request({
        url: `/mdap-private/api/v1/toolTemplate/save`,
        method: "post",
        data: data,
    });
}


// 批量更新工具模板项
export function toolTemplateUpdate(data) {
    return request({
        url: `/mdap-private/api/v1/toolTemplate/update`,
        method: "put",
        data: data,
    });
}


// 批量查询
export function selectBynodeId(data) {
    return request({
        url: `/mdap/api/v1/toolTemplate/selectByNodeId`,
        method: "post",
        data: data,
    });
}


// 样本文件集批量修改
export function updateSampleFileSet(data) {
    return request({
        url: `/mdap-private/api/v1/sample/updateSampleFileSet`,
        method: "put",
        data: data,
    });
}



// 根据任务实例id获取执行结果
export function queryJobResult(jobInstanceId,data) {
    return request({
        url: `/mdap-private/api/v1/executeResult/job/${jobInstanceId}/instance/list`,
        method: "post",
        data:data
    });
}


// 工作流列表参数设置接口
export function queryWfResult(wfInstanceId) {
    return request({
        url: `/mdap-private/api/v1/executeResult/wf/${wfInstanceId}/instance/list`,
        method: "post",
        data:wfInstanceId
    });
}


// 根据文件id下载文件
export function executeResultDownLoad(fileId) {
    return request({
url: `/mdap/api/v1/executeResult/file/${fileId}/download`,
    method: "post",
    data:fileId
});
}


// 根据流程实例id下载执行结果文件
export function wfInstanceDownLoad(wfInstanceId) {
    return request({
        url: `/mdap-private/api/v1/executeResult/wf/${wfInstanceId}/instance/download`,
        method: "post",
        data:wfInstanceId
    });
}


// 根据流程实例id获取执行结果
export function wfInstanceList(wfInstanceId) {
    return request({
        url: `/mdap-private/api/v1/executeResult/wf/${wfInstanceId}/instance/list`,
        method: "post",
        data:wfInstanceId
    });
}



// 根据流程实例id获取执行结果
export function jobInstanceList(jobInstanceId) {
    return request({
        url: `/mdap-private/api/v1/executeResult/job/${jobInstanceId}/instance/list`,
        method: "post",
        data:jobInstanceId
    });
}


// 样本列表查询
export function sampleSelectList(data) {
    return request({
        url: `/mdap/api/v1/sample/selectList`,
        method: "post",
        data
    });
}

//================================================

// 数据库索引列表破
export function databaseList(data) {
    return request({
        url: `/mdap-private/api/v1/databaseIndex/list`,
        method: "post",
        data
    });
}

/**
 * 查询组织结构
 * @param {*} data
 */
export function treeselect(data) {
    return request({
        url: `/system/dept/treeselect`,
        method: "get",
        params: data
    });
}

/**
 * 查询用户列表
 * @param {*} data
 */
export function listUser(data) {
    return request({
      url: '/system/user/list',
      method: 'get',
      params: data
    })
}

/**
 * 查询我的好友
 * @param {*} data
 */
export function getMyFriends(data) {
    return request({
      url: '/mdap-private/api/v1/myFriend/list',
      method: 'post',
      data
    })
}

/**
 * 新增好友
 * @param {*} data
 */
export function addMyFriends(data) {
    return request({
      url: '/mdap-private/api/v1/myFriend/save',
      method: 'post',
      data
    })
}

/**
 * 删除好友
 * @param {*} data
 */
export function delMyFriends(data) {
    return request({
      url: '/mdap-private/api/v1/myFriend/deleteByIds',
      method: 'post',
      data
    })
}

// 根据参数键名查询参数值
export function getConfigKey(configKey) {
    return request({
      url: '/system/config/configKey/' + configKey,
      method: 'get'
    })
  }

// 查询用户详细
export function getUser(userId) {
return request({
    url: '/system/user/' + praseStrEmpty(userId),
    method: 'get'
})
}


/**
 * 查询所有团队
 * @param {*} data
 */
export function getAllTeam(data) {
    return request({
      url: '/mdap-private/api/v1/team/allTeam',
      method: 'post',
      data
    })
}

/**
 * 查询我创建的团队
 * @param {*} data
 */
export function getMyCreateTeam(data) {
    return request({
      url: '/mdap-private/api/v1/team/myCreate',
      method: 'post',
      data
    })
}
/**
 * 查询我参与的团队
 * @param {*} data
 */
export function getMyJoinTeam(data) {
    return request({
      url: '/mdap-private/api/v1/team/myJoin',
      method: 'post',
      data
    })
}
/**
 * 新增团队
 * @param {*} data
 */
export function addTeam(data) {
    return request({
      url: '/mdap-private/api/v1/team/save',
      method: 'post',
      data
    })
}
/**
 * 修改团队
 * @param {*} data
 */
export function updateTeam(data) {
    return request({
      url: '/mdap-private/api/v1/team/update',
      method: 'put',
      data
    })
}

/**
 * 退出团队
 * @param {*} data
 */
 export function quitTeam(data) {
    return request({
      url: '/mdap-private/api/v1/team/quit',
      method: 'post',
      data
    })
}

/**
 * 删除团队
 * @param {*} data
 */
export function delTeam(data) {
    return request({
      url: '/mdap-private/api/v1/team/deleteByIds',
      method: 'post',
      data
    })
}

/**
 * 查询团队成员列表
 * @param {*} data
 */
export function getTeamMember(data) {
    return request({
      url: '/mdap-private/api/v1/teamMember/list',
      method: 'post',
      data
    })
}
/**
 * 新增团队成员
 * @param {*} data
 */
export function addTeamMember(data) {
    return request({
      url: '/mdap-private/api/v1/teamMember/save',
      method: 'post',
      data
    })
}

/**
 * 删除团队成员
 * @param {*} data
 */
export function delTeamMember(data) {
    return request({
      url: '/mdap-private/api/v1/teamMember/deleteByIds',
      method: 'post',
      data
    })
}

// 项目管理——根据id查询详情
export function getProjectInfoById(dataId) {
    return request({
      url: '/mdap-private/api/v1/project/selectInfoById/' + dataId,
      method: 'get'
    })
}

/**
 * 经典案例-列表
 * @param {*} data
 */
export function queryClassicCasesList(data) {
    return request({
      url: '/mdap-private/api/v1/project/classicCases',
      method: 'post',
      data
    })
}

/**
 * 首页未读消息数量
 */
export function getNotificationUnreadCount() {
    return request({
        url: '/mdap-private/api/v1/notification/unread/count',
        method: 'get'
    })
}

/**
 * 首页校验token是否过期
 */
 export function testToken() {
    return request({
        url: '/mdap-private/api/v1/test/token/expired',
        method: 'get'
    })
}
//项目-获取文件树
export function executeResultDataSpace(data) {
    return request({
        url: `/mdap-private/api/v1/executeResult/file/save/dataSpace`,
        method: "post",
        data:data
    })
}
//保存工具参数
export function toolTemplatesaveOrUpdate(data) {
    return request({
        url: `/mdap-private/api/v1/toolTemplate/saveOrUpdate`,
        method: "post",
        data:data
    })
}

// 查询流程实例状态
export function workflowinstanceStatus(wfInstanceId) {
    return request({
        url: `/mdap-private/api/v1/workflow/instance/${wfInstanceId}/status`,
        method: "get",
    });
}
//获取当前在跑流程数量
export function queryWorkCount() {
    return request({
        url: `/mdap-private/api/v1/jobs/running/count`,
        method: "get",
    })
}
//获取系统注册的用户数量
export function queryUserCount() {
    return request({
        url: `/system/user/queryUserCount`,
        method: "post",
    })
}
// 删除流程记录
export function deleteWorkflow(wfInstanceId) {
    return request({
        url: `/mdap-private/api/v1/workflow/instance/${wfInstanceId}`,
        method: "delete",
    });
}
// 获取所有node节点
export function getNodeCheckAll() {
    return request({
        url: `/mdap-private/api/v1/nodeCheck/all`,
        method: "get",
    });
}

// 停止调试
export function stopDebugger(instanceId) {
    return request({
        url: `/mdap-private/api/v1/jobs/instance/${instanceId}/stop`,
        method: "post",
    });
}

// 删除文件校验
export function handleSampleCheck(data) {
    return request({
        url: `/mdap-private/api/v1/handleSampleCheck`,
        method: "post",
        data:data
    });
}

// 删除样本清空工具参数
export function deletesample(data) {
    return request({
        url: "/mdap-private/api/v1/toolTemplate/clear",
        method: "post",
        data
    })
}
// 下载文件并发送邮箱
export function downloadAndSendEmail(data) {
    return request({
        url: `/mdap-private/api/v1/dlTask/download/sendEmail`,
        method: "post",
        data:data
    });
}
// 根据出图的files文件找出图显示scatter table
export function appendFileIdShowCsvPage(data) {
    return request({
        url: `/mdap-private/api/v1/csv/page`,
        method: "post",
        data:data
    });
}
// 修改cluster颜色或基因 run
export function geneClusterRunRecordRun(data) {
    return request({
        url: `/mdap-private/api/v1/geneClusterRunRecord/run`,
        method: "post",
        data:data
    });
}
// 获取分群颜色
export function geneClusterColor(jobInstanceId,imageName) {
    return request({
        url: `/mdap-private/api/v1/geneClusterRunRecord/${jobInstanceId}/cluster/color`,
        method: "get",
        params:{
            imageName:imageName
        }
    });
}
// 获取基因数据
export function getGeneListByInputInfo(jobInstanceId,geneName,imageName) {
    return request({
        url: `/mdap-private/api/v1/geneClusterRunRecord/${jobInstanceId}/gene/list`,
        method: "get",
        params:{
            geneName:geneName,
            imageName:imageName
        }
    });
}
// 获取运行结果图片
export function getResultImage(jobInstanceId,imageName) {
    return request({
        url: `/mdap-private/api/v1/geneClusterRunRecord/${jobInstanceId}/run/result/images?imageName=${imageName}`,
        method: "get"
    });
}
// 获取运行状态
export function getRunStatus(jobInstanceId,imageName) {
    return request({
        url: `/mdap-private/api/v1/geneClusterRunRecord/${jobInstanceId}/run/status?imageName=${imageName}`,
        method: "get"
    });
}
// 获取运行的gene
export function getRunParamsGene(jobInstanceId,imageName) {
    return request({
        url: `/mdap-private/api/v1/geneClusterRunRecord/${jobInstanceId}/gene/run/params?imageName=${imageName}`,
        method: "get"
    });
}
// 添加运行错误日志
export function getRunErrorLog(jobInstanceId,type,imageName) {
    return request({
        url: `/mdap-private/api/v1/geneClusterRunRecord/${jobInstanceId}/${type}/run/log?imageName=${imageName}`,
        method: "get"
    });
}
// ccc 运行
export function cccRunRecordRun(data) {
    return request({
        url: `/mdap-private/api/v1/pathwayPlot/run`,
        method: "post",
        data:data
    });
}
// ccc 结果图
export function cccRunRecordResultImage(jobInstanceId,imageName) {
    return request({
        url: `/mdap-private/api/v1/pathwayPlot/${jobInstanceId}/run/result/images?imageName=${imageName}`,
        method: "get"
    });
}
// ccc 运行结果状态
export function cccRunStatus(jobInstanceId,imageName) {
    return request({
        url: `/mdap-private/api/v1/pathwayPlot/${jobInstanceId}/run/status?imageName=${imageName}`,
        method: "get"
    });
}
// 查看ccc 运行日志
export function cccRunLogInfo(jobInstanceId,imageName) {
    return request({
        url: `/mdap-private/api/v1/pathwayPlot/${jobInstanceId}/run/log?imageName=${imageName}`,
        method: "get"
    });
}
// 获取pathway 列表
export function getPathwayList(jobInstanceId,pathway,imageName) {
    return request({
        url: `/mdap-private/api/v1/pathwayPlot/${jobInstanceId}/pathway/list`,
        method: "get",
        params:{
            imageName,
            pathway
        }
    });
}


export function batchBase64(data) {
    return request({
        url: '/mdap-private/api/v1/file/batch/thumb/base64',
        method: "post",
        data:data
    });
}

export function queryPreView(fileId) {
    return request({
        url: `/mdap-private/api/v1/file/${fileId}/base64`,
        method: "get",
    });
}

